/* Trin-galleriet inde i en variant: numrene under billedet skifter billedet.
   Galleriet står for sig selv - instruktionen ved siden af markeres ikke, fordi
   nummereringen i de to ikke folger hinanden hele vejen. */
(function () {
  function setUp(gallery) {
    const image = gallery.querySelector('[data-gallery-image]');
    const dots = Array.from(gallery.querySelectorAll('.step-gallery__dot'));
    if (!image || dots.length === 0) return;

    let syncArrows = function () {};

    function show(dot) {
      const source = dot.dataset.src;
      if (source) {
        image.src = source;
        image.alt = dot.dataset.alt || '';
      }
      dots.forEach((other) => other.removeAttribute('aria-current'));
      dot.setAttribute('aria-current', 'true');
      syncArrows();
    }

    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    function currentIndex() {
      const active = gallery.querySelector('.step-gallery__dot[aria-current]');
      return Math.max(0, dots.indexOf(active));
    }

    // Pilene er slaaet fra i hver ende i stedet for at rulle rundt: raekkefolgen er en
    // montage, og et spring fra sidste trin til oversigten ville laeses som en fejl.
    syncArrows = function () {
      const index = currentIndex();
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === dots.length - 1;
    };

    function step(offset) {
      const target = dots[currentIndex() + offset];
      if (target) show(target);
    }

    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => show(dot));
      dot.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        const next = dots[(index + step + dots.length) % dots.length];
        next.focus();
        show(next);
      });
    });

    syncArrows();
  }

  document.querySelectorAll('[data-step-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryBound) return;
    gallery.dataset.galleryBound = 'true';
    setUp(gallery);
  });
})();
